/* eslint-disable react/forbid-prop-types,react/no-unused-prop-types,no-shadow */

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import styled from 'styled-components';
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import { ExpandMore as ExpandMoreIcon } from '@mui/icons-material';
import MomentTz from 'moment-timezone';
import _ from 'lodash';
import { v4 } from 'uuid';

import {
  toggleAssetAccess,
  clearLogs,
  queryAssetDownloadLogs,
  resetAssetAccess,
} from '../../../../state/assetAccess';
import { isOwnerOfAsset } from '../../../../utils/assetDetails/isOwnerOfAsset';
import { selectIsUserVaultSuperAdmin, selectUserRole } from '../../../../state/user/userOrgRole';
import Warning from '../../Warning';

const tableRowHeight = 55;

const AccordionContainer = styled(Accordion)`
  width: 100%;
  background-color: transparent;
`;

const AccordionDetailsContainer = styled(AccordionDetails)`
  width: 100%;
`;

const Drawer = styled(TableContainer)`
  max-height: ${tableRowHeight * 6}px !important;
  overflow-y: auto;
`;

const DrawerRow = styled(TableRow)`
  height: ${tableRowHeight}px;
`;

const headCells = [
  { id: 'orgName', label: 'Organization' },
  { id: 'actionDate', label: 'Time' },
];

class AssetAccess extends PureComponent {
  handleToggle = () => {
    const {
      isOpen,
      rawAssetDetails,
      toggleAssetAccess,
      queryAssetDownloadLogs,
      clearLogs,
    } = this.props;

    if (isOpen) {
      clearLogs();
      toggleAssetAccess();
    } else {
      queryAssetDownloadLogs(rawAssetDetails._id, true);
    }
  };

  componentDidUpdate(prevProps) {
    const { resetAssetAccess, rawAssetDetails } = this.props;

    if (!_.isEqual(rawAssetDetails, prevProps.rawAssetDetails)) {
      resetAssetAccess();
    }
  }

  render() {
    const {
      rawAssetDetails,
      isOpen,
      logs,
      securityProfiles: { isLoaded, idValueMapping },
      userRole,
      isSuperAdmin,
    } = this.props;

    const isOwner = isLoaded ? isOwnerOfAsset(userRole, rawAssetDetails, idValueMapping) : false;

    if (!isOwner && !isSuperAdmin) {
      return null;
    }

    return (
      <AccordionContainer
        expanded={isOpen}
        onChange={this.handleToggle}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
        >
          <Typography>Asset Downloads</Typography>
        </AccordionSummary>
        <AccordionDetailsContainer>
          <Warning
            isWarning={logs.length === 0}
            message="Downloads not found"
            fullWidth
          />
          {logs.length > 0 && (
            <Drawer>
              <Table size="small">
                <TableHead>
                  <TableRow>
                    {headCells.map((cell) => (
                      <TableCell
                        key={cell.id}
                        align="center"
                      >
                        {cell.label}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {logs.map((log) => (
                    <DrawerRow
                      key={v4()}
                    >
                      <TableCell align="center">
                        {log._source.orgName}
                      </TableCell>
                      <TableCell align="center">
                        {MomentTz.tz(log._source.actionDate, MomentTz.tz.guess()).format('L LT')}
                      </TableCell>
                    </DrawerRow>
                  ))}
                </TableBody>
              </Table>
            </Drawer>
          )}
        </AccordionDetailsContainer>
      </AccordionContainer>
    );
  }
}

AssetAccess.propTypes = {
  rawAssetDetails: PropTypes.object.isRequired,
  isOpen: PropTypes.bool.isRequired,
  isQuerying: PropTypes.bool.isRequired,
  logs: PropTypes.array.isRequired,
  securityProfiles: PropTypes.object.isRequired,
  userRole: PropTypes.object.isRequired,
  isSuperAdmin: PropTypes.bool.isRequired,
  toggleAssetAccess: PropTypes.func.isRequired,
  clearLogs: PropTypes.func.isRequired,
  queryAssetDownloadLogs: PropTypes.func.isRequired,
  resetAssetAccess: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  isOpen: state.assetAccess.isOpen,
  isQuerying: state.assetAccess.isQuerying,
  logs: state.assetAccess.logs,
  securityProfiles: state.securityProfiles,
  userRole: selectUserRole(state),
  isSuperAdmin: selectIsUserVaultSuperAdmin(state),
});

const mapDispatchToProps = {
  toggleAssetAccess,
  clearLogs,
  queryAssetDownloadLogs,
  resetAssetAccess,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(AssetAccess);
